import { Chip, ChipProps } from '@mui/material';
import { CostItemStatus } from 'gql/index';
import { useCostItemStatusOptions } from './BudgetItemTable/hooks/useCostItemStatusOptions';

type Props = Omit<ChipProps, 'label'> & {
  status: CostItemStatus;
};

const color: Record<CostItemStatus, ChipProps['color']> = {
  Planned: 'info',
  Completed: 'success',
  InProgress: 'info',
};

export const CostItemStatusChip: React.FC<Props> = ({ status, ...chipProps }) => {
  const statusOptions = useCostItemStatusOptions();
  const statusOption = statusOptions.find(o => o.value === status);

  return (
    <Chip
      color={color[status]}
      label={statusOption?.label ?? ''}
      {...chipProps}
    />
  );
};

